<script>
  import { goto } from '$app/navigation';

  import { getCurrentUserStore } from '@stores/current_user';

  import Mixpanel from '@utils/mixpanel';
  import { onMount } from 'svelte';

  export let src = '/images/logo-black.svg';
  export let width = 82;
  export let href = '/';

  if (!href) {
    href = '/';
  }

  let currentUser = getCurrentUserStore('default');

  onMount(() => {
    currentUser.subscribe((x) => (currentUser = x));
  });
</script>

<style>
  a {
    outline: none;
  }
</style>

<a
  href={href}
  on:click|preventDefault|stopPropagation={() => {
    Mixpanel.track('Home Click', {});

    if (currentUser && currentUser.id) {
      window.discoverSelectedOption = undefined;
      window.discoverScrollPositions = {};
      window.discoverGroupsCache = {};
      goto('/discover');
    } else {
      goto(href);
    }
  }}
  class={$$props.class}>
  <span style="padding: 20px; margin: -20px;">
    <img class={$$props.imgClass} src={src} style="width: {width}px" />
  </span>
</a>
